<!--  -->
<div
  *ngIf="type === 'ellipsis-text'"
  class="ellipsis-text-container"
  [title]="row[field]"
  [ngClass]="{ 'is-zoomed': isZoomed }"
>
  {{ row[field] }}
</div>
<!--  -->

<!--  -->
<div
  *ngIf="type === 'text'"
  class="regular-text-container"
  [ngClass]="{ 'is-zoomed': isZoomed }"
>
  {{ row[field] }}
</div>
<!--  -->

<!--  -->
<div
  *ngIf="type === 'text-with-info-tooltip'"
  class="text-with-tooltip-container"
>
  <div class="regular-text-container" [ngClass]="{ 'is-zoomed': isZoomed }">
    {{ row[field] }}
  </div>
  <motif-tooltip variant="alternate">
    <motif-tooltip-trigger>
      <motif-icon
        class="info-icon"
        size="16"
        [attr.id]="'description-' + row['order']"
        #tooltipIcon
        [iconFunction]="IconoirInfoCircle"
        [tabIndex]="0"
        (click)="onTooltipClick($event, false)"
      ></motif-icon>
    </motif-tooltip-trigger>
    <motif-tooltip-content placement="auto">
      <div class="tooltip">
        <strong>Purpose</strong>
        <br />
        <p>
          {{ row["purpose"] }}
        </p>
        <br />
        <strong>Expected output</strong>
        <br />
        <p class="preserve-linebreaks">
          {{ formatTooltipContent(row["expected_output"]) }}
        </p>
      </div>
      <motif-tooltip-arrow></motif-tooltip-arrow>
    </motif-tooltip-content>
  </motif-tooltip>
</div>
<!--  -->

<!--  -->
<div
  *ngIf="type === 'text-quoting-document'"
  class="text-quoting-doc-container"
  [ngClass]="{ 'is-zoomed': isZoomed }"
>
  {{ row[field] }}
  <br /><br />
  <div class="ref-pages-text">
    The result is based on
    <!--  -->
    @for (fileDetails of reportFilesDetails; track $index) {
    <!--  -->
    @for(page of fileDetails.pages; track $index){
    <p
      (click)="goToPage(page, fileDetails.fileId)"
      (keydown.enter)="goToPage(page, fileDetails.fileId)"
      [tabIndex]="0"
    >
      {{ page }}
    </p>
    <!-- If we are not in the last page apply a comma-->
    @if($index !== fileDetails.pages.length - 1){ , }
    <!--  -->
    }
    <!--  -->
    @if(fileDetails.pages.length > 0){
    <!--  -->
    of {{ fileDetails.filename }}
    <!--  -->
    }
    <!-- if we have more than one page, concat 'and' -->
    @if(reportFilesDetails.length > 1 && $index === reportFilesDetails.length -
    2 && fileDetails.pages.length > 0){ and }
    <!--  -->
    }
  </div>
</div>
<!--  -->

<!--  -->
<div
  *ngIf="type === 'text-quoting-document-with-tooltip'"
  class="text-quoting-doc-with-tooltip-container"
>
  <div class="text-quoting-doc-container" [ngClass]="{ 'is-zoomed': isZoomed }">
    {{ row[field] }}
    <br /><br />
    <div class="ref-pages-text">
      The result is based on
      <!--  -->
      @for (fileDetails of reportFilesDetails; track $index) {
      <!--  -->
      @for(page of fileDetails.pages; track $index){
      <p
        (click)="goToPage(page, fileDetails.fileId)"
        (keydown.enter)="goToPage(page, fileDetails.fileId)"
        [tabIndex]="0"
      >
        {{ page }}
      </p>
      <!-- If we are not in the last page apply a comma-->
      @if($index !== fileDetails.pages.length - 1){ , }
      <!--  -->
      }
      <!--  -->
      @if(fileDetails.pages.length > 0){
      <!--  -->
      of {{ fileDetails.filename }}
      <!--  -->
      }
      <!-- if we have more than one page, concat 'and' -->
      @if(reportFilesDetails.length > 1 && $index === reportFilesDetails.length
      - 2 && fileDetails.pages.length > 0){ and }
      <!--  -->
      }
    </div>
  </div>
  <motif-tooltip variant="alternate">
    <motif-tooltip-trigger>
      <motif-icon
        class="info-icon"
        size="16"
        [attr.id]="'ai-analysis-' + row['order']"
        #tooltipIcon
        [iconFunction]="IconoirInfoCircle"
        [tabIndex]="0"
        (click)="onTooltipClick($event, false)"
      ></motif-icon>
    </motif-tooltip-trigger>
    <motif-tooltip-content placement="auto">
      <div class="tooltip">
        <strong>Suggested Actions</strong>
        <br />
        <p>
          {{ row["suggested_actions"] }}
        </p>
      </div>
      <motif-tooltip-arrow></motif-tooltip-arrow>
    </motif-tooltip-content>
  </motif-tooltip>
</div>
<!--  -->

<!--  -->
<div *ngIf="type === 'link'">
  <a [href]="row[field]" target="_blank" rel="noopener noreferrer">
    {{ row[field] || "Link" }}
  </a>
</div>
<!--  -->

<!--  -->
<div
  *ngIf="type === 'flagged-number'"
  class="flagged-number-container"
  [ngClass]="{ 'is-zoomed': isZoomed }"
>
  <div
    *ngIf="row['flagged']"
    class="flagged-row-flex"
    [ngClass]="{ 'is-zoomed': isZoomed }"
  >
    <motif-icon
      [iconFunction]="IconoirWhiteFlag"
      class="flag-icon"
      size="16"
    ></motif-icon>
    <p class="flag-number">{{ row[field] }}</p>
  </div>

  <p *ngIf="!row['flagged']" class="flag-number">
    {{ row[field] }}
  </p>
</div>
<!--  -->

<!--  -->
<div
  *ngIf="type === 'currency'"
  class="center-text no-flex"
  [ngClass]="{ 'is-zoomed': isZoomed }"
>
  {{ formatCurrency(row[field]) }}
</div>
<!--  -->

<!--  -->
<div
  *ngIf="type === 'percentage'"
  class="center-text no-flex"
  [ngClass]="{ 'is-zoomed': isZoomed }"
>
  {{ formatPercentage(row[field]) }}
</div>
<!--  -->

<!--  -->
<div *ngIf="type === 'equal-text-field'">
  <!-- if row[field] === true, the status should be Not Equal -->
  <div
    class="center-text"
    [ngClass]="{ green: !row[field], red: row[field], 'is-zoomed': isZoomed }"
  >
    {{ row[field] ? "Not Equal" : "Equal" }}
  </div>
</div>

<!--  -->
<div *ngIf="type === 'equal-text-field-fs-vs-comp'">
  <div
    class="center-text"
    [ngClass]="{ green: !row[field], red: row[field], 'is-zoomed': isZoomed }"
  >
    @if(row['order'] === 18){

    <p
      class="paragraph"
      [title]="
        row[field]
          ? 'Notes present in the Tax Computation'
          : 'No notes present in the Tax Computation'
      "
    >
      {{
        row[field]
          ? "Notes present in the Tax Computation"
          : "No notes present in the Tax Computation"
      }}
    </p>

    } @else {
    {{ row[field] ? "Not Equal" : "Equal" }}
    }

    <!-- Tooltip -->
    <motif-tooltip variant="alternate">
      <motif-tooltip-trigger>
        <motif-icon
          class="info-icon"
          size="16"
          [attr.id]="'fs-vs-comp-' + row['order']"
          #tooltipIcon
          [iconFunction]="IconoirInfoCircle"
          [tabIndex]="0"
          (click)="onTooltipClick($event, false)"
        ></motif-icon>
      </motif-tooltip-trigger>
      <motif-tooltip-content placement="auto">
        <div class="tooltip">
          <strong>Suggested Actions</strong>
          <br />
          <p class="preserve-linebreaks">
            {{ formatTooltipContent(row["suggested_actions"]) }}
          </p>
        </div>
        <motif-tooltip-arrow></motif-tooltip-arrow>
      </motif-tooltip-content>
    </motif-tooltip>
    <!-- Tooltip -->
  </div>
</div>
<!--  -->

<!--  -->
<div *ngIf="type === 'equal-text-field-cy-vs-py'">
  <div
    class="center-text"
    [ngClass]="{ green: !row[field], red: row[field], 'is-zoomed': isZoomed }"
  >
    @if(row['order'] === 1){
    {{ row["cy_value"] === row["py_value"] ? "Equal" : "Not Equal" }}
    }@else {
    {{ row[field] ? "Not Equal" : "Equal" }}
    }

    <!-- Tooltip -->
    <motif-tooltip variant="alternate">
      <motif-tooltip-trigger>
        <motif-icon
          class="info-icon"
          size="16"
          [attr.id]="'cy-vs-py-' + row['order']"
          #tooltipIcon
          [iconFunction]="IconoirInfoCircle"
          [tabIndex]="0"
          (click)="onTooltipClick($event, false)"
        ></motif-icon>
      </motif-tooltip-trigger>
      <motif-tooltip-content placement="auto">
        <div class="tooltip">
          <strong>Suggested Actions</strong>
          <br />
          <p>
            {{ row["suggested_actions"] }}
          </p>
        </div>
        <motif-tooltip-arrow></motif-tooltip-arrow>
      </motif-tooltip-content>
    </motif-tooltip>
    <!-- Tooltip -->
  </div>
</div>
<!--  -->
